export const HIDDEN_REPORT_SOURCE_TAGS = [
  'report-source/covenant_review',
  'report-source/levfininsights_emea',
  'report-source/levfininsights_us',
];
